


export class MainPublicationView {
    constructor() {
        this.template = document.getElementById('publication-event-template');
        this.container = document.getElementById('publication-main-container');
    }

    render(state) { 

        if (!(state && Object.keys(state).length > 0)) { return;}

        const publication = state.data;

        const clone = this.template.content.cloneNode(true);

        clone.querySelector('article.post').dataset.id = publication.id;
        clone.querySelector('.preview').href = publication.url;

        const img = clone.querySelector('img');
        img.src = publication.preview;
        img.dataset.src = publication.preview;
        img.alt = publication.title;

        clone.querySelector('.title a').href = publication.url;
        clone.querySelector('.title a').textContent = publication.title;

        clone.querySelector('.anno').textContent = publication.announce;

        clone.querySelector('.ci.like span').textContent = publication.counters.likes.value;
        clone.querySelector('.ci.comments span').textContent = publication.counters.comments.value;
        clone.querySelector('.ci.comments a').href = publication.url + '#comments';

        clone.querySelector('.ci.views span').textContent = publication.counters.views.value;

        if (publication.hasOwnProperty('isActiveLike') && publication.isActiveLike) { 
            clone.querySelector('.ci.like').classList.add('toggled');
        }

        const existingArticlePost = this.container.querySelector('article.post');
        if (existingArticlePost) {

            this.container.replaceChild(clone, existingArticlePost);
        } else {

            const existingDivPost = this.container.querySelector('div.post');
            if (existingDivPost) {
                this.container.replaceChild(clone, existingDivPost);
            } else {

                this.container.prepend(clone);
            }
        }
    }
}